/* eslint-disable no-case-declarations */
import {
  FETCH_EPG_CHANNELS_ERROR,
  FETCH_EPG_CHANNELS_INIT,
  FETCH_EPG_CHANNELS_SUCCESS,
} from '../../actions/epgChannels/constants';

const initialState = {
  inProgress: false,
  success: false,
  data: [],
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EPG_CHANNELS_INIT:
      return {
        ...state,
        inProgress: true,
        success: false,
        data: [],
        error: null,
      };
    case FETCH_EPG_CHANNELS_SUCCESS:
      return {
        ...state,
        inProgress: false,
        success: true,
        data: action.payload,
        error: null,
      };
    case FETCH_EPG_CHANNELS_ERROR:
      return {
        ...state,
        inProgress: false,
        success: false,
        data: [],
        error: action.error,
      };
    default:
      return state;
  }
};
